import { formatPhoneNumber, isValidPhoneNumber } from 'react-phone-number-input';

import { Address } from 'components/applications/applications.types';

export const MONETARY_PREFIX = '$';

const maskValue = (value: string | number) => {
  return `${MONETARY_PREFIX}${value
    .toString()
    .replace(/\D/g, '')
    .split('')
    .reverse()
    .map((digit, index) => (index !== 0 && index % 3 === 0 ? `${digit},` : digit))
    .reverse()
    .join('')}`;
};

export const removeCurrencySign = (value: string | number) => {
  return value.toString().replace(MONETARY_PREFIX, '');
};

export const removeNonDigits = (value: any) => {
  return value?.toString().replace(/\D/g, '').toString();
};

export const maskMonetaryValueAllowZero = (value: string | number | null) => {
  if (!value || !removeCurrencySign(value)) {
    return '';
  }

  const digitsOnly = Number(removeNonDigits(value));

  if (digitsOnly === 0) {
    return `${MONETARY_PREFIX}0`;
  }

  return maskValue(digitsOnly);
};

export const capitalize = (value: string) => {
  const lowerCase = value.toLowerCase();

  return lowerCase.charAt(0).toUpperCase() + lowerCase.slice(1);
};

export const getStreetAddressFromAddressVariable = (address?: Address | null) => {
  if (!address) {
    return null;
  }

  const streetNumber = address.street_number ? `${address.street_number} ` : '';
  const streetName = address.street_name ? `${address.street_name}` : '';

  return `${streetNumber}${streetName}`;
};

export const getStreetNumberFromStreetAddress = (streetAddress: string) => {
  const splittedString = streetAddress ? streetAddress.split(' ') : [];
  const streetNumber = Number(splittedString[0]);

  return streetNumber ? streetNumber.toString() : '';
};

export const getStreetNameFromStreetAddress = (streetAddress: string) => {
  const streetNumber = getStreetNumberFromStreetAddress(streetAddress);

  if (streetNumber) {
    return streetAddress.replace(`${streetNumber} `, '');
  }

  return streetAddress;
};

export const convertPhoneNumberForDisplay = (phone: string | null): string => {
  if (!phone) {
    return '';
  }

  if (!isValidPhoneNumber(phone)) {
    return phone;
  }

  return formatPhoneNumber(phone);
};

export const prepareVariableForTableDisplay = (value: any) => {
  return value || '-';
};

export const maskEmail = (email: string, preserveCount: number = 2) => {
  const splitEmail = email.split('@');
  const formatted =
    splitEmail[0].slice(0, preserveCount) + '*'.repeat(splitEmail[0].length - 2) + splitEmail[0].slice(-1);

  return `${formatted}@${splitEmail[1]}`;
};

export const einMask = (taxId: string) => {
  let formatNumber = taxId?.replace(/\D/g, '');

  return formatNumber.length > 2 ? `${formatNumber.slice(0, 2)}-${formatNumber.slice(2, 9)}` : formatNumber;
};

export const getFirstNameWithInitial = (firstName: string, lastName: string): string => {
  return `${firstName} ${lastName.charAt(0)}.`;
};
